import createReducer from 'reducers/createReducer';

import { Popup } from 'actions/actionTypes';

const INITIAL_STATE = {
    isView: false,
    type: '',
    data: {},
    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [Popup.CHANGE_POPUP_VIEW]: (state, action) => {
        state.isView = true;
    },
    [Popup.CHANGE_POPUP_TYPE]: (state, action) => {
        state.type = action.payload.type;
        state.data = action.payload.data;
    },
    [Popup.CLOSE_POPUP]: (state, action) => {
        state.isView = INITIAL_STATE.isView;
        state.type = INITIAL_STATE.type;
    },
});

export default reducer;
